<template>
  <div>
    <div class="preloader" style="--n: 5" v-show="visible">
      <div class="dot" style="--i: 0"></div>
      <div class="dot" style="--i: 1"></div>
      <div class="dot" style="--i: 2"></div>
      <div class="dot" style="--i: 3"></div>
      <div class="dot" style="--i: 4"></div>
    </div>
  </div>
</template>

<script>
import { EventBus } from "@/eventHub.js";

export default {
  name: "preloader",
  data() {
    return {
      visible: true
    };
  },
  created() {
    EventBus.$on("showPreLoader", () => {
      this.visible = true;
    });

    EventBus.$on("hidePreLoader", () => {
      this.visible = false;
    });
  }
};
</script>

<style lang="scss" scoped>
$d: 2em;
$t: 1.5s;
div {
  position: relative;
  .preloader {
    background-color: transparent;
    position: fixed;
    top: 50%;
    transform: translate(-50%, 0);
  }
  .dot {
    background: tomato;
    color: white;

    &,
    &:after {
      display: inline-block;
      width: $d;
      height: $d;
      border-radius: 50%;
      animation: a $t calc(((var(--i) + var(--o, 0)) / var(--n) - 1) *#{$t})
        infinite;
    }

    &:after {
      --o: 1;
      background: currentcolor;
      content: "";
    }
  }

  @keyframes a {
    0%,
    50% {
      transform: scale(0);
    }
  }
}
</style>
